import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["points", "stroke-width"]
const _hoisted_4 = ["x2", "y2"]
const _hoisted_5 = ["points"]
const _hoisted_6 = ["x", "y", "fill", "onMouseenter"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { ref, computed, nextTick } from "vue";
import { ElementBalance } from "@/types/calculators";
import { elementColors, elementLabels } from "@/constants/bazi";
import { useI18n } from "vue-i18n";

const maxValue = 5;
const radius = 180;
const center = 225;

// 5 углов — равномерно по окружности

export default /*@__PURE__*/_defineComponent({
  __name: 'ElementsBalance',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const tooltip = ref<{
  visible: boolean;
  x: number;
  y: number;
  selectedIndex: number;
}>({
  visible: false,
  x: 0,
  y: 0,
  selectedIndex: 0,
});
const containerRef = ref<HTMLDivElement | null>(null);
const tooltipRef = ref<HTMLElement | null>(null);
const extraShift = ref(0);

const labels = computed(() => props.data.map((e) => e.element));

function getPoint(idx: number, value: number, scale = 1) {
  const angle = ((Math.PI * 2) / 5) * idx - Math.PI / 2;
  const r = (value / maxValue) * radius * scale;
  return {
    x: center + Math.cos(angle) * r,
    y: center + Math.sin(angle) * r,
  };
}

// Контур "заполненного" многоугольника
const polygonPoints = computed(() =>
  props.data
    .map((e, i) => {
      const { x, y } = getPoint(i, Math.max(0, Math.min(maxValue, e.value)));
      return `${x},${y}`;
    })
    .join(" ")
);

// Координаты для подписей (немного дальше)
const labelPoints = computed(() =>
  props.data.map((_, i) => getPoint(i, 1.17 * maxValue))
);

function showTip(i: number, evt: MouseEvent) {
  const target = evt.target as SVGGraphicsElement;
  const rect = target.getBoundingClientRect();
  const containerRect = containerRef.value?.getBoundingClientRect();

  if (!containerRect) return;

  tooltip.value = {
    visible: true,
    x: rect.left - containerRect.left + rect.width / 2,
    y: rect.bottom - containerRect.top + 8,
    selectedIndex: i,
  };
  nextTick(adjustPosition);
}

function hideTip() {
  tooltip.value.visible = false;
  extraShift.value = 0;
}

function adjustPosition() {
  const rect = tooltipRef.value?.getBoundingClientRect();
  if (!rect) return;

  extraShift.value = 0;
  if (rect.right > window.innerWidth) {
    extraShift.value = window.innerWidth - rect.right - 8;
  }
  if (rect.left < 0) {
    extraShift.value = -rect.left + 8;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "w-full sm:w-[480px] relative",
      ref_key: "containerRef",
      ref: containerRef
    }, [
      (_openBlock(), _createElementBlock("svg", {
        class: "bg-transparent w-full h-auto",
        viewBox: `0 0 ${center * 2} ${center * 2}`,
        preserveAspectRatio: "xMidYMid meet"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (step) => {
          return _createElementVNode("g", { key: step }, [
            _createElementVNode("polygon", {
              points: 
              props.data
                .map((_, i) => {
                  const p = getPoint(i, step);
                  return `${p.x},${p.y}`;
                })
                .join(' ')
            ,
              fill: "none",
              stroke: "#000",
              "stroke-width": step === 5 ? 2 : 1,
              opacity: "0.5"
            }, null, 8, _hoisted_3)
          ])
        }), 64)),
        _createElementVNode("g", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (_, i) => {
            return (_openBlock(), _createElementBlock("line", {
              key: i,
              x1: center,
              y1: center,
              x2: getPoint(i, maxValue).x,
              y2: getPoint(i, maxValue).y,
              stroke: "#000",
              "stroke-dasharray": "3,2",
              "stroke-width": "1"
            }, null, 8, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("polygon", {
          points: polygonPoints.value,
          fill: "#0dcaf0",
          "fill-opacity": "0.55",
          stroke: "#0dcaf0",
          "stroke-width": "2"
        }, null, 8, _hoisted_5),
        _createElementVNode("g", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelPoints.value, (pt, i) => {
            return (_openBlock(), _createElementBlock("text", {
              key: i,
              x: pt.x,
              y: pt.y,
              "text-anchor": "middle",
              "alignment-baseline": "middle",
              class: "cursor-pointer pointer-events-auto text-[24px] font-bold",
              fill: _unref(elementColors)[props.data[i].element],
              onMouseenter: ($event: any) => (showTip(i, $event)),
              onMouseleave: hideTip
            }, _toDisplayString(labels.value[i]), 41, _hoisted_6))
          }), 128))
        ])
      ], 8, _hoisted_2)),
      (tooltip.value.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "tooltipRef",
            ref: tooltipRef,
            class: "absolute z-50 rounded-[10px] bg-brown text-white px-3 py-2 text-left",
            style: _normalizeStyle({
          left: tooltip.value.x + 'px',
          top: tooltip.value.y + 'px',
          transform: `translateX(-50%) translateX(${extraShift.value}px)`,
        })
          }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(elementLabels)[props.data[tooltip.value.selectedIndex].element] ||
            props.data[tooltip.value.selectedIndex].element), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)("calculators.bazi.results.element-balance.hexagram.meaning", {
              meaning: props.data[tooltip.value.selectedIndex].value,
            })), 1),
            (props.data[tooltip.value.selectedIndex].role == 'unfavorable')
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)(
              "calculators.bazi.results.element-balance.hexagram.unfavourable-role"
            )), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)(
              "calculators.bazi.results.element-balance.hexagram.favourable-role"
            )), 1))
          ], 4))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})